import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fileUrl } from "@/lib/api";
import { ImageOff } from "lucide-react";

export default function CollectibleCard({ collectible, index }) {
  const cover = collectible.photos && collectible.photos.length > 0 ? collectible.photos[0] : null;
  const spanClass = index % 5 === 0 ? "md:col-span-2 md:row-span-2" : "md:col-span-1";

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.06 }}
      className={spanClass}
    >
      <Link
        to={`/collectible/${collectible.id}`}
        className="group block relative h-full min-h-[280px] bg-surface border border-white/10 overflow-hidden hover:border-glow-primary/60 hover:-translate-y-1 hover:shadow-[0_0_28px_rgba(0,240,255,0.18)] transition-[transform,border-color,box-shadow] duration-300"
        data-testid={`collectible-card-${collectible.id}`}
      >
        <div className="absolute inset-0 overflow-hidden">
          {cover ? (
            <img
              src={fileUrl(cover.storage_path)}
              alt={collectible.title}
              className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-[transform,opacity] duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-white/20">
              <ImageOff className="w-10 h-10" />
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        </div>

        <div className="relative h-full flex flex-col justify-end p-6">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-glow-primary mb-2">
            {String(index + 1).padStart(2, "0")} / Collectible
          </span>
          <h3 className="font-heading font-700 text-white text-xl md:text-2xl tracking-tight leading-tight">
            {collectible.title}
          </h3>
          {collectible.photos?.length > 0 && (
            <span className="mt-2 font-mono text-xs text-white/50">
              {collectible.photos.length} {collectible.photos.length === 1 ? "PHOTO" : "PHOTOS"}
            </span>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
